import { Avatar as ChakraAvatar, Text } from '@chakra-ui/react';

import { AvatarProps } from './avatar.props';

export const Avatar = ({ src, initial, ...props }: AvatarProps): JSX.Element => {
    return (
        <ChakraAvatar.Root {...props}>
            {!initial && <ChakraAvatar.Fallback />}
            <ChakraAvatar.Image src={src} />
            {initial ? (
                <Text as={'span'} fontSize={'xl'} color={'gray.900'}>
                    {initial}
                </Text>
            ) : null}
        </ChakraAvatar.Root>
    );
};
